import { ConfigProvider, Layout, theme } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import UserRoutes from "../routes/userRoutes";
import WebFooter from "./components/navigation/webfooter";
import TopHeader from "./components/navigation/header";

const UserApp = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        token: {
          Layout: {
            headerPadding: 0,
          },
        },
      }}
    >
      <Layout>
        <Header
          className="flex justify-between items-center text-lg px-0 h-min"
          style={{ background: colorBgContainer }}
        >
          <TopHeader />
        </Header>
        <Content className="bg-white rounded-xl">
          <UserRoutes />
        </Content>
        <Footer className="p-0">
          <WebFooter />
        </Footer>
      </Layout>
    </ConfigProvider>
  );
};
export default UserApp;
